import React from 'react'

const SelectInput = React.forwardRef((props, ref) => (
  <label className='partner-label'>
    {props.label}
    <select className='form-control' {...props} ref={ref}>
      { props.options.map((o, i) => {
        const value = Array.isArray(o) ? o[0] : o
        const label = Array.isArray(o) ? o[1] : o
        return <option key={i} value={value}>{label}</option>
      })}
    </select>
  </label>
))

export default SelectInput
